export default __webpack_public_path__ + "static/media/leftJoystickArrow.65a2d76c.svg";